/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channeltypelabel2Inputs */

const en_channeltypelabel2 = /** @type {(inputs: Channeltypelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_channeltypelabel2 = /** @type {(inputs: Channeltypelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Channeltypelabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channeltypelabel2 = /** @type {((inputs?: Channeltypelabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channeltypelabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channeltypelabel2(inputs)
	return de_channeltypelabel2(inputs)
});
export { channeltypelabel2 as "channelTypeLabel" }